const applyCashTokenTranslations = {
  'redeemToken.applyCashToken': 'Apply cash token',
  'redeemToken.applyCashTokenHint': 'Give a cash token you created or received. It is delivered to this invoice.',
  'redeemToken.applyCashTokenConfirm': 'Give this cash token',
  'redeemToken.applyCashTokenPreview': 'This cash token will settle {amount} toward the invoice.',
  'redeemToken.applyCashTokenLeftover': 'If the token is larger than the amount due, the leftover stays as a cash token.',
  'redeemToken.applyCashTokenSameCode': 'Enter a cash token, not this invoice code.',
  'redeemToken.applyCashTokenNotCash': 'That code is not a cash token.',
  'redeemToken.applyCashTokenCurrency': 'This cash token is {tokenCurrency}. The invoice is {invoiceCurrency}.',
  'redeemToken.applyCashTokenFailed': 'Cash token could not be applied',
  'redeemToken.applyCashTokenCancelPreview': 'Use a different token',
  'redeemToken.applyCashTokenUnusable': 'That cash token cannot be used.',
  'redeemToken.applyCashTokenMissingAmount': 'That cash token did not reveal a usable amount.',
  'redeemToken.applyCashTokenMissingCurrency': 'That cash token did not reveal a currency.',
};

export const redeemTokenTranslations = {
  en: {
    ...applyCashTokenTranslations,
    'redeemToken.noDataScanned': 'No data scanned.',
    'redeemToken.invalidQRCode': 'Invalid QR code format.',
    'redeemToken.noCodeExtracted': 'Could not extract a code from the QR scan.',
    'redeemToken.mustBeLoggedIn': 'You must be logged in to redeem tokens. Please log in and try again.',
    'redeemToken.enterCompleteCode': 'Please enter a complete 6-character code.',
    'redeemToken.invalidTokenCode': 'Invalid token code',
    'redeemToken.invoicePaidSuccess': 'Invoice Paid Successfully!',
    'redeemToken.invoicePaidSuccessDesc': 'Invoice {{invoiceKey}} has been automatically paid.',
    'redeemToken.tokenRedeemedSuccess': 'Token Redeemed Successfully!',
    'redeemToken.tokenRedeemedSuccessDesc': 'Token {{tokenKey}} has been redeemed to your account.',
    'redeemToken.tokenProcessingFailed': 'Token Processing Failed',
    'redeemToken.tokenProcessingFailedDesc': 'Unable to process token. Please check the code and try again.',
    'redeemToken.invoicePaymentCanceled': 'Invoice Payment Canceled',
    'redeemToken.invoicePaymentCanceledDesc': 'You chose not to pay the invoice at this time.',
    'redeemToken.tokenRedemptionCanceled': 'Token Redemption Canceled',
    'redeemToken.tokenRedemptionCanceledDesc': 'You chose not to redeem the token at this time.',
    'redeemToken.tokenCode': 'Token Code',
    'redeemToken.enterCode': 'Enter the 6-character token code or paste it',
    'redeemToken.redeeming': 'Redeeming...',
    'redeemToken.redeemToken': 'Redeem Token',
    'redeemToken.scanQRCode': 'Scan QR Code',
    'redeemToken.partialPaymentSuccess': 'Partial Payment Successful!',
    'redeemToken.paymentSuccess': 'Payment Successful!',
    'redeemToken.paymentSuccessDesc': 'Successfully paid {{currency}} {{amount}} for invoice{{isPartial}}.',
    'redeemToken.isIDToken': 'This is an ID token',
    'redeemToken.idTokenHint': 'ID tokens verify identity; no money is transferred',
    'redeemToken.idTokenVerified': 'Identity Verified',
    'redeemToken.idTokenRedeemedSuccess': 'ID token redeemed successfully',
    'redeemToken.continue': 'Continue',
    'redeemToken.idField.firstName': 'First name',
    'redeemToken.idField.lastName': 'Last name',
    'redeemToken.idField.username': 'Username',
    'redeemToken.idField.email': 'Email',
    'redeemToken.idField.telephone': 'Phone',
    'redeemToken.idField.phone': 'Phone',
    'redeemToken.idField.address': 'Address',
    'redeemToken.idField.scope': 'Permissions',
    'redeemToken.idField.canCredit': 'Credit currencies',
    'redeemToken.idField.expiresAt': 'Expires at',
    'redeemToken.idField.message': 'Message',
    'redeemToken.redemptionPanelIntro': 'Review amount, fees, and net below. Then confirm or choose not to proceed.',
    'redeemToken.tokenValueLabel': 'Token value',
    'redeemToken.processingFeeLabel': 'Processing fee',
    'redeemToken.netAmountReceivedLabel': 'Net amount received',
    'redeemToken.tokenCodeLabel': 'Token code',
    'redeemToken.processing': 'Processing...',
    'redeemToken.confirmDeposit': 'Confirm deposit',
    'redeemToken.doNothing': 'Do nothing',
    'redeemToken.depositFullAmount': 'Deposit full amount',
    'redeemToken.depositAmount': 'Deposit {{amount}}',
    'redeemToken.invoiceRedemptionIntro': 'Review payment amount, fees, and total below. Then pay or choose not to proceed.',
    'redeemToken.amountDueLabel': 'Amount due (remaining)',
    'redeemToken.totalDebitedLabel': 'Total debited from balance',
    'redeemToken.confirmPayInvoice': 'Confirm payment',
    'redeemToken.payDifferentAmount': 'Pay a different amount',
  },
  es: {
    ...applyCashTokenTranslations,
    'redeemToken.noDataScanned': 'No se escanearon datos.',
    'redeemToken.invalidQRCode': 'Formato de código QR no válido.',
    'redeemToken.noCodeExtracted': 'No se pudo extraer un código del escaneo QR.',
    'redeemToken.mustBeLoggedIn': 'Debes iniciar sesión para canjear tokens. Por favor, inicia sesión y vuelve a intentarlo.',
    'redeemToken.enterCompleteCode': 'Por favor, introduce un código completo de 6 caracteres.',
    'redeemToken.invalidTokenCode': 'Código de token no válido',
    'redeemToken.invoicePaidSuccess': '¡Factura Pagada con Éxito!',
    'redeemToken.invoicePaidSuccessDesc': 'La factura {{invoiceKey}} ha sido pagada automáticamente.',
    'redeemToken.tokenRedeemedSuccess': '¡Token Canjeado con Éxito!',
    'redeemToken.tokenRedeemedSuccessDesc': 'El token {{tokenKey}} ha sido canjeado en tu cuenta.',
    'redeemToken.tokenProcessingFailed': 'Falló el Procesamiento del Token',
    'redeemToken.tokenProcessingFailedDesc': 'No se pudo procesar el token. Por favor, comprueba el código e inténtalo de nuevo.',
    'redeemToken.invoicePaymentCanceled': 'Pago de Factura Cancelado',
    'redeemToken.invoicePaymentCanceledDesc': 'Has decidido no pagar la factura en este momento.',
    'redeemToken.tokenRedemptionCanceled': 'Canje de Token Cancelado',
    'redeemToken.tokenRedemptionCanceledDesc': 'Has decidido no canjear el token en este momento.',
    'redeemToken.tokenCode': 'Código del Token',
    'redeemToken.enterCode': 'Introduce el código del token de 6 caracteres o pégalo',
    'redeemToken.redeeming': 'Canjeando...',
    'redeemToken.redeemToken': 'Canjear Token',
    'redeemToken.scanQRCode': 'Escanear Código QR',
    'redeemToken.partialPaymentSuccess': '¡Pago Parcial Exitoso!',
    'redeemToken.paymentSuccess': '¡Pago Exitoso!',
    'redeemToken.paymentSuccessDesc': 'Pagado con éxito {{currency}} {{amount}} para la factura{{isPartial}}.',
    'redeemToken.isIDToken': 'Este es un token de identidad',
    'redeemToken.idTokenHint': 'Los tokens de identidad verifican la identidad; no se transfiere dinero',
    'redeemToken.idTokenVerified': 'Identidad verificada',
    'redeemToken.idTokenRedeemedSuccess': 'Token de identidad canjeado correctamente',
    'redeemToken.continue': 'Continuar',
    'redeemToken.redemptionPanelIntro': 'Revise el importe, comisiones y neto. Luego confirme o elija no continuar.',
    'redeemToken.tokenValueLabel': 'Valor del token',
    'redeemToken.processingFeeLabel': 'Comisión de procesamiento',
    'redeemToken.netAmountReceivedLabel': 'Importe neto recibido',
    'redeemToken.tokenCodeLabel': 'Código del token',
    'redeemToken.processing': 'Procesando...',
    'redeemToken.confirmDeposit': 'Confirmar depósito',
    'redeemToken.doNothing': 'No hacer nada',
    'redeemToken.depositFullAmount': 'Depositar importe completo',
    'redeemToken.depositAmount': 'Depositar {{amount}}',
    'redeemToken.invoiceRedemptionIntro': 'Revise el importe, comisiones y total. Luego pague o elija no continuar.',
    'redeemToken.amountDueLabel': 'Importe pendiente (restante)',
    'redeemToken.totalDebitedLabel': 'Total debitado del saldo',
    'redeemToken.confirmPayInvoice': 'Confirmar pago',
    'redeemToken.payDifferentAmount': 'Pagar otro importe',
  },
  fr: {
    ...applyCashTokenTranslations,
    'redeemToken.noDataScanned': 'Aucune donnée scannée.',
    'redeemToken.invalidQRCode': 'Format de code QR invalide.',
    'redeemToken.noCodeExtracted': 'Impossible d\'extraire un code du scan QR.',
    'redeemToken.mustBeLoggedIn': 'Vous devez être connecté pour utiliser les tokens. Veuillez vous connecter et réessayer.',
    'redeemToken.enterCompleteCode': 'Veuillez entrer un code complet de 6 caractères.',
    'redeemToken.invalidTokenCode': 'Code de token invalide',
    'redeemToken.invoicePaidSuccess': 'Facture payée avec succès !',
    'redeemToken.invoicePaidSuccessDesc': 'La facture {{invoiceKey}} a été automatiquement payée.',
    'redeemToken.tokenRedeemedSuccess': 'Token utilisé avec succès !',
    'redeemToken.tokenRedeemedSuccessDesc': 'Le token {{tokenKey}} a été utilisé sur votre compte.',
    'redeemToken.tokenProcessingFailed': 'Échec du traitement du token',
    'redeemToken.tokenProcessingFailedDesc': 'Impossible de traiter le token. Veuillez vérifier le code et réessayer.',
    'redeemToken.invoicePaymentCanceled': 'Paiement de facture annulé',
    'redeemToken.invoicePaymentCanceledDesc': 'Vous avez choisi de ne pas payer la facture pour le moment.',
    'redeemToken.tokenRedemptionCanceled': 'Utilisation du token annulée',
    'redeemToken.tokenRedemptionCanceledDesc': 'Vous avez choisi de ne pas utiliser le token pour le moment.',
    'redeemToken.tokenCode': 'Code du token',
    'redeemToken.enterCode': 'Entrez le code de token de 6 caractères ou collez-le',
    'redeemToken.redeeming': 'Utilisation...',
    'redeemToken.redeemToken': 'Utiliser le token',
    'redeemToken.scanQRCode': 'Scanner le code QR',
    'redeemToken.partialPaymentSuccess': 'Paiement partiel réussi !',
    'redeemToken.paymentSuccess': 'Paiement réussi !',
    'redeemToken.paymentSuccessDesc': 'Paiement réussi de {{currency}} {{amount}} pour la facture{{isPartial}}.',
    'redeemToken.isIDToken': 'Ceci est un token d\'identité',
    'redeemToken.idTokenHint': 'Les tokens d\'identité vérifient l\'identité; aucun argent n\'est transféré',
    'redeemToken.idTokenVerified': 'Identité vérifiée',
    'redeemToken.idTokenRedeemedSuccess': 'Token d\'identité utilisé avec succès',
    'redeemToken.continue': 'Continuer',
    'redeemToken.redemptionPanelIntro': 'Vérifiez le montant, les frais et le net. Confirmez ou n\'agissez pas.',
    'redeemToken.tokenValueLabel': 'Valeur du token',
    'redeemToken.processingFeeLabel': 'Frais de traitement',
    'redeemToken.netAmountReceivedLabel': 'Montant net reçu',
    'redeemToken.tokenCodeLabel': 'Code du token',
    'redeemToken.processing': 'Traitement...',
    'redeemToken.confirmDeposit': 'Confirmer le dépôt',
    'redeemToken.doNothing': 'Ne rien faire',
    'redeemToken.depositFullAmount': 'Déposer le montant total',
    'redeemToken.depositAmount': 'Déposer {{amount}}',
    'redeemToken.invoiceRedemptionIntro': 'Vérifiez le montant, les frais et le total. Payez ou n\'agissez pas.',
    'redeemToken.amountDueLabel': 'Montant dû (restant)',
    'redeemToken.totalDebitedLabel': 'Total débité du solde',
    'redeemToken.confirmPayInvoice': 'Confirmer le paiement',
    'redeemToken.payDifferentAmount': 'Payer un autre montant',
  },
  sq: {
    ...applyCashTokenTranslations,
    'redeemToken.noDataScanned': 'Nuk u skanuan të dhëna.',
    'redeemToken.invalidQRCode': 'Format i pavlefshëm i kodit QR.',
    'redeemToken.noCodeExtracted': 'Nuk mund të nxirrej një kod nga skanimi QR.',
    'redeemToken.mustBeLoggedIn': 'Duhet të jeni të kyçur për të shlyer tokena. Ju lutem hyni dhe provoni përsëri.',
    'redeemToken.enterCompleteCode': 'Ju lutem vendosni një kod të plotë 6-karakterësh.',
    'redeemToken.invalidTokenCode': 'Kod tokeni i pavlefshëm',
    'redeemToken.invoicePaidSuccess': 'Fatura u Pagua me Sukses!',
    'redeemToken.invoicePaidSuccessDesc': 'Fatura {{invoiceKey}} është paguar automatikisht.',
    'redeemToken.tokenRedeemedSuccess': 'Tokeni u Shlye me Sukses!',
    'redeemToken.tokenRedeemedSuccessDesc': 'Tokeni {{tokenKey}} është shlyer në llogarinë tuaj.',
    'redeemToken.tokenProcessingFailed': 'Përpunimi i Tokenit Dështoi',
    'redeemToken.tokenProcessingFailedDesc': 'Nuk mund të përpunohet tokeni. Ju lutem kontrolloni kodin dhe provoni përsëri.',
    'redeemToken.invoicePaymentCanceled': 'Pagesa e Faturës u Anulua',
    'redeemToken.invoicePaymentCanceledDesc': 'Zgjodhët të mos paguani faturën në këtë kohë.',
    'redeemToken.tokenRedemptionCanceled': 'Shlyerja e Tokenit u Anulua',
    'redeemToken.tokenRedemptionCanceledDesc': 'Zgjodhët të mos shlyeni tokenin në këtë kohë.',
    'redeemToken.tokenCode': 'Kodi i Tokenit',
    'redeemToken.enterCode': 'Vendosni kodin e tokenit 6-karakterësh ose ngjisni atë',
    'redeemToken.redeeming': 'Duke shlyer...',
    'redeemToken.redeemToken': 'Shlye Tokenin',
    'redeemToken.scanQRCode': 'Skano Kodin QR',
    'redeemToken.partialPaymentSuccess': 'Pagesa e Pjesshme e Suksesshme!',
    'redeemToken.paymentSuccess': 'Pagesa e Suksesshme!',
    'redeemToken.paymentSuccessDesc': 'U pagua me sukses {{currency}} {{amount}} për faturën{{isPartial}}.',
    'redeemToken.isIDToken': 'Ky është një token identiteti',
    'redeemToken.idTokenHint': 'Tokenet e identitetit verifikojnë identitetin; nuk transferohet para',
    'redeemToken.idTokenVerified': 'Identiteti u verifikua',
    'redeemToken.idTokenRedeemedSuccess': 'Tokeni i identitetit u shlye me sukses',
    'redeemToken.continue': 'Vazhdo',
    'redeemToken.redemptionPanelIntro': 'Review amount, fees, and net below. Then confirm or choose not to proceed.',
    'redeemToken.tokenValueLabel': 'Token value',
    'redeemToken.processingFeeLabel': 'Processing fee',
    'redeemToken.netAmountReceivedLabel': 'Net amount received',
    'redeemToken.tokenCodeLabel': 'Token code',
    'redeemToken.processing': 'Processing...',
    'redeemToken.confirmDeposit': 'Confirm deposit',
    'redeemToken.doNothing': 'Do nothing',
    'redeemToken.depositFullAmount': 'Deposit full amount',
    'redeemToken.depositAmount': 'Deposit {{amount}}',
    'redeemToken.invoiceRedemptionIntro': 'Review payment amount, fees, and total below. Then pay or choose not to proceed.',
    'redeemToken.amountDueLabel': 'Amount due (remaining)',
    'redeemToken.totalDebitedLabel': 'Total debited from balance',
    'redeemToken.confirmPayInvoice': 'Confirm payment',
    'redeemToken.payDifferentAmount': 'Pay a different amount',
  },
  ru: {
    ...applyCashTokenTranslations,
    'redeemToken.noDataScanned': 'Данные не отсканированы.',
    'redeemToken.invalidQRCode': 'Неверный формат QR-кода.',
    'redeemToken.noCodeExtracted': 'Не удалось извлечь код из QR-сканирования.',
    'redeemToken.mustBeLoggedIn': 'Вы должны быть авторизованы для погашения токенов. Пожалуйста, войдите и попробуйте снова.',
    'redeemToken.enterCompleteCode': 'Пожалуйста, введите полный 6-символьный код.',
    'redeemToken.invalidTokenCode': 'Неверный код токена',
    'redeemToken.invoicePaidSuccess': 'Счет успешно оплачен!',
    'redeemToken.invoicePaidSuccessDesc': 'Счет {{invoiceKey}} был автоматически оплачен.',
    'redeemToken.tokenRedeemedSuccess': 'Токен успешно погашен!',
    'redeemToken.tokenRedeemedSuccessDesc': 'Токен {{tokenKey}} был погашен на ваш счет.',
    'redeemToken.tokenProcessingFailed': 'Обработка токена не удалась',
    'redeemToken.tokenProcessingFailedDesc': 'Не удалось обработать токен. Пожалуйста, проверьте код и попробуйте снова.',
    'redeemToken.invoicePaymentCanceled': 'Оплата счета отменена',
    'redeemToken.invoicePaymentCanceledDesc': 'Вы решили не оплачивать счет в данный момент.',
    'redeemToken.tokenRedemptionCanceled': 'Погашение токена отменено',
    'redeemToken.tokenRedemptionCanceledDesc': 'Вы решили не погашать токен в данный момент.',
    'redeemToken.tokenCode': 'Код токена',
    'redeemToken.enterCode': 'Введите 6-символьный код токена или вставьте его',
    'redeemToken.redeeming': 'Погашение...',
    'redeemToken.redeemToken': 'Погасить токен',
    'redeemToken.scanQRCode': 'Сканировать QR-код',
    'redeemToken.partialPaymentSuccess': 'Частичная оплата успешна!',
    'redeemToken.paymentSuccess': 'Оплата успешна!',
    'redeemToken.paymentSuccessDesc': 'Успешно оплачено {{currency}} {{amount}} за счет{{isPartial}}.',
    'redeemToken.isIDToken': 'Это токен идентификации',
    'redeemToken.idTokenHint': 'Токены идентификации проверяют личность; деньги не переводятся',
    'redeemToken.idTokenVerified': 'Идентификация подтверждена',
    'redeemToken.idTokenRedeemedSuccess': 'Токен идентификации успешно погашен',
    'redeemToken.continue': 'Продолжить',
    'redeemToken.redemptionPanelIntro': 'Review amount, fees, and net below. Then confirm or choose not to proceed.',
    'redeemToken.tokenValueLabel': 'Token value',
    'redeemToken.processingFeeLabel': 'Processing fee',
    'redeemToken.netAmountReceivedLabel': 'Net amount received',
    'redeemToken.tokenCodeLabel': 'Token code',
    'redeemToken.processing': 'Processing...',
    'redeemToken.confirmDeposit': 'Confirm deposit',
    'redeemToken.doNothing': 'Do nothing',
    'redeemToken.depositFullAmount': 'Deposit full amount',
    'redeemToken.depositAmount': 'Deposit {{amount}}',
    'redeemToken.invoiceRedemptionIntro': 'Review payment amount, fees, and total below. Then pay or choose not to proceed.',
    'redeemToken.amountDueLabel': 'Amount due (remaining)',
    'redeemToken.totalDebitedLabel': 'Total debited from balance',
    'redeemToken.confirmPayInvoice': 'Confirm payment',
    'redeemToken.payDifferentAmount': 'Pay a different amount',
  },

  de: {
    ...applyCashTokenTranslations,
    'redeemToken.noDataScanned': 'Keine Daten gescannt.',
    'redeemToken.invalidQRCode': 'Ungültiges QR-Code-Format.',
    'redeemToken.noCodeExtracted': 'Code konnte nicht aus dem QR-Scan extrahiert werden.',
    'redeemToken.mustBeLoggedIn': 'Sie müssen angemeldet sein, um Tokens einzulösen. Bitte melden Sie sich an und versuchen Sie es erneut.',
    'redeemToken.enterCompleteCode': 'Bitte geben Sie einen vollständigen 6-stelligen Code ein.',
    'redeemToken.invalidTokenCode': 'Ungültiger Token-Code',
    'redeemToken.invoicePaidSuccess': 'Rechnung erfolgreich bezahlt!',
    'redeemToken.invoicePaidSuccessDesc': 'Rechnung {{invoiceKey}} wurde automatisch bezahlt.',
    'redeemToken.tokenRedeemedSuccess': 'Token erfolgreich eingelöst!',
    'redeemToken.tokenRedeemedSuccessDesc': 'Token {{tokenKey}} wurde auf Ihr Konto eingelöst.',
    'redeemToken.tokenProcessingFailed': 'Token-Verarbeitung fehlgeschlagen',
    'redeemToken.tokenProcessingFailedDesc': 'Token konnte nicht verarbeitet werden. Bitte überprüfen Sie den Code und versuchen Sie es erneut.',
    'redeemToken.invoicePaymentCanceled': 'Rechnungszahlung abgebrochen',
    'redeemToken.invoicePaymentCanceledDesc': 'Sie haben sich entschieden, die Rechnung zu diesem Zeitpunkt nicht zu bezahlen.',
    'redeemToken.tokenRedemptionCanceled': 'Token-Einlösung abgebrochen',
    'redeemToken.tokenRedemptionCanceledDesc': 'Sie haben sich entschieden, den Token zu diesem Zeitpunkt nicht einzulösen.',
    'redeemToken.tokenCode': 'Token-Code',
    'redeemToken.enterCode': 'Geben Sie den 6-stelligen Token-Code ein oder fügen Sie ihn ein',
    'redeemToken.redeeming': 'Einlösen...',
    'redeemToken.redeemToken': 'Token einlösen',
    'redeemToken.scanQRCode': 'QR-Code scannen',
    'redeemToken.partialPaymentSuccess': 'Teilzahlung erfolgreich!',
    'redeemToken.paymentSuccess': 'Zahlung erfolgreich!',
    'redeemToken.paymentSuccessDesc': 'Erfolgreich {{currency}} {{amount}} für Rechnung{{isPartial}} bezahlt.',
    'redeemToken.isIDToken': 'Dies ist ein ID-Token',
    'redeemToken.idTokenHint': 'ID-Tokens verifizieren die Identität; es wird kein Geld überwiesen',
    'redeemToken.idTokenVerified': 'Identität verifiziert',
    'redeemToken.idTokenRedeemedSuccess': 'ID-Token erfolgreich eingelöst',
    'redeemToken.continue': 'Weiter',
    'redeemToken.redemptionPanelIntro': 'Review amount, fees, and net below. Then confirm or choose not to proceed.',
    'redeemToken.tokenValueLabel': 'Token value',
    'redeemToken.processingFeeLabel': 'Processing fee',
    'redeemToken.netAmountReceivedLabel': 'Net amount received',
    'redeemToken.tokenCodeLabel': 'Token code',
    'redeemToken.processing': 'Processing...',
    'redeemToken.confirmDeposit': 'Confirm deposit',
    'redeemToken.doNothing': 'Do nothing',
    'redeemToken.depositFullAmount': 'Deposit full amount',
    'redeemToken.depositAmount': 'Deposit {{amount}}',
    'redeemToken.invoiceRedemptionIntro': 'Review payment amount, fees, and total below. Then pay or choose not to proceed.',
    'redeemToken.amountDueLabel': 'Amount due (remaining)',
    'redeemToken.totalDebitedLabel': 'Total debited from balance',
    'redeemToken.confirmPayInvoice': 'Confirm payment',
    'redeemToken.payDifferentAmount': 'Pay a different amount',
  },

  sr: {
    ...applyCashTokenTranslations,
    'redeemToken.noDataScanned': 'Нема скенираних података.',
    'redeemToken.invalidQRCode': 'Неважећи формат QR кода.',
    'redeemToken.noCodeExtracted': 'Није могуће извући код из QR скенирања.',
    'redeemToken.mustBeLoggedIn': 'Морате бити пријављени да бисте искористили токене. Молимо пријавите се и покушајте поново.',
    'redeemToken.enterCompleteCode': 'Молимо унесите комплетан 6-карактерни код.',
    'redeemToken.invalidTokenCode': 'Неважећи код токена',
    'redeemToken.invoicePaidSuccess': 'Фактура успешно плаћена!',
    'redeemToken.invoicePaidSuccessDesc': 'Фактура {{invoiceKey}} је аутоматски плаћена.',
    'redeemToken.tokenRedeemedSuccess': 'Токен успешно искоришћен!',
    'redeemToken.tokenRedeemedSuccessDesc': 'Токен {{tokenKey}} је искоришћен на вашем налогу.',
    'redeemToken.tokenProcessingFailed': 'Обрада токена неуспешна',
    'redeemToken.tokenProcessingFailedDesc': 'Није могуће обрадити токен. Молимо проверите код и покушајте поново.',
    'redeemToken.invoicePaymentCanceled': 'Плаћање фактуре отказано',
    'redeemToken.invoicePaymentCanceledDesc': 'Изабрали сте да не платите фактуру у овом тренутку.',
    'redeemToken.tokenRedemptionCanceled': 'Откуп токена отказан',
    'redeemToken.tokenRedemptionCanceledDesc': 'Изабрали сте да не искористите токен у овом тренутку.',
    'redeemToken.tokenCode': 'Код токена',
    'redeemToken.enterCode': 'Унесите 6-карактерни код токена или га налепите',
    'redeemToken.redeeming': 'Искоришћавање...',
    'redeemToken.redeemToken': 'Искористи токен',
    'redeemToken.scanQRCode': 'Скенирај QR код',
    'redeemToken.partialPaymentSuccess': 'Делимично плаћање успешно!',
    'redeemToken.paymentSuccess': 'Плаћање успешно!',
    'redeemToken.paymentSuccessDesc': 'Успешно плаћено {{currency}} {{amount}} за фактуру{{isPartial}}.',
    'redeemToken.isIDToken': 'Ово је токен идентитета',
    'redeemToken.idTokenHint': 'Токени идентитета верификују идентитет; новац се не преноси',
    'redeemToken.idTokenVerified': 'Идентитет верификован',
    'redeemToken.idTokenRedeemedSuccess': 'Токен идентитета успешно искоришћен',
    'redeemToken.continue': 'Настави',
    'redeemToken.redemptionPanelIntro': 'Review amount, fees, and net below. Then confirm or choose not to proceed.',
    'redeemToken.tokenValueLabel': 'Token value',
    'redeemToken.processingFeeLabel': 'Processing fee',
    'redeemToken.netAmountReceivedLabel': 'Net amount received',
    'redeemToken.tokenCodeLabel': 'Token code',
    'redeemToken.processing': 'Processing...',
    'redeemToken.confirmDeposit': 'Confirm deposit',
    'redeemToken.doNothing': 'Do nothing',
    'redeemToken.depositFullAmount': 'Deposit full amount',
    'redeemToken.depositAmount': 'Deposit {{amount}}',
    'redeemToken.invoiceRedemptionIntro': 'Review payment amount, fees, and total below. Then pay or choose not to proceed.',
    'redeemToken.amountDueLabel': 'Amount due (remaining)',
    'redeemToken.totalDebitedLabel': 'Total debited from balance',
    'redeemToken.confirmPayInvoice': 'Confirm payment',
    'redeemToken.payDifferentAmount': 'Pay a different amount',
  },
  pl: {
    ...applyCashTokenTranslations,
    'redeemToken.noDataScanned': 'Nie zeskanowano danych.',
    'redeemToken.invalidQRCode': 'Nieprawidłowy format kodu QR.',
    'redeemToken.noCodeExtracted': 'Nie można wyodrębnić kodu ze skanowania QR.',
    'redeemToken.mustBeLoggedIn': 'Musisz być zalogowany, aby wykorzystać tokeny. Proszę się zalogować i spróbować ponownie.',
    'redeemToken.enterCompleteCode': 'Proszę wprowadzić pełny 6-znakowy kod.',
    'redeemToken.invalidTokenCode': 'Nieprawidłowy kod tokena',
    'redeemToken.invoicePaidSuccess': 'Faktura Opłacona Pomyślnie!',
    'redeemToken.invoicePaidSuccessDesc': 'Faktura {{invoiceKey}} została automatycznie opłacona.',
    'redeemToken.tokenRedeemedSuccess': 'Token Wykorzystany Pomyślnie!',
    'redeemToken.tokenRedeemedSuccessDesc': 'Token {{tokenKey}} został wykorzystany na Twoim koncie.',
    'redeemToken.tokenProcessingFailed': 'Przetwarzanie Tokena Nie Powiodło Się',
    'redeemToken.tokenProcessingFailedDesc': 'Nie można przetworzyć tokena. Proszę sprawdzić kod i spróbować ponownie.',
    'redeemToken.invoicePaymentCanceled': 'Płatność Faktury Anulowana',
    'redeemToken.invoicePaymentCanceledDesc': 'Wybrałeś nie płacenie faktury w tym momencie.',
    'redeemToken.tokenRedemptionCanceled': 'Wykorzystanie Tokena Anulowane',
    'redeemToken.tokenRedemptionCanceledDesc': 'Wybrałeś nie wykorzystanie tokena w tym momencie.',
    'redeemToken.tokenCode': 'Kod Tokena',
    'redeemToken.enterCode': 'Wprowadź 6-znakowy kod tokena lub wklej go',
    'redeemToken.redeeming': 'Wykorzystywanie...',
    'redeemToken.redeemToken': 'Wykorzystaj Token',
    'redeemToken.scanQRCode': 'Skanuj Kod QR',
    'redeemToken.partialPaymentSuccess': 'Częściowa Płatność Zakończona Sukcesem!',
    'redeemToken.paymentSuccess': 'Płatność Zakończona Sukcesem!',
    'redeemToken.paymentSuccessDesc': 'Pomyślnie opłacono {{currency}} {{amount}} za fakturę{{isPartial}}.',
    'redeemToken.isIDToken': 'To jest token identyfikacyjny',
    'redeemToken.idTokenHint': 'Tokeny identyfikacyjne weryfikują tożsamość; nie transferuje się pieniędzy',
    'redeemToken.idTokenVerified': 'Tożsamość zweryfikowana',
    'redeemToken.idTokenRedeemedSuccess': 'Token identyfikacyjny wykorzystany pomyślnie',
    'redeemToken.continue': 'Kontynuuj',
    'redeemToken.redemptionPanelIntro': 'Review amount, fees, and net below. Then confirm or choose not to proceed.',
    'redeemToken.tokenValueLabel': 'Token value',
    'redeemToken.processingFeeLabel': 'Processing fee',
    'redeemToken.netAmountReceivedLabel': 'Net amount received',
    'redeemToken.tokenCodeLabel': 'Token code',
    'redeemToken.processing': 'Processing...',
    'redeemToken.confirmDeposit': 'Confirm deposit',
    'redeemToken.doNothing': 'Do nothing',
    'redeemToken.depositFullAmount': 'Deposit full amount',
    'redeemToken.depositAmount': 'Deposit {{amount}}',
    'redeemToken.invoiceRedemptionIntro': 'Review payment amount, fees, and total below. Then pay or choose not to proceed.',
    'redeemToken.amountDueLabel': 'Amount due (remaining)',
    'redeemToken.totalDebitedLabel': 'Total debited from balance',
    'redeemToken.confirmPayInvoice': 'Confirm payment',
    'redeemToken.payDifferentAmount': 'Pay a different amount',
  },
  el: {
    ...applyCashTokenTranslations,
    'redeemToken.noDataScanned': 'Δεν σαρώθηκαν δεδομένα.',
    'redeemToken.invalidQRCode': 'Μη έγκυρη μορφή QR κωδικού.',
    'redeemToken.noCodeExtracted': 'Δεν ήταν δυνατή η εξαγωγή κωδικού από τη σάρωση QR.',
    'redeemToken.mustBeLoggedIn': 'Πρέπει να είστε συνδεδεμένοι για να εξαργυρώσετε διακριτικά. Παρακαλώ συνδεθείτε και δοκιμάστε ξανά.',
    'redeemToken.enterCompleteCode': 'Παρακαλώ εισάγετε έναν πλήρη κωδικό 6 χαρακτήρων.',
    'redeemToken.invalidTokenCode': 'Μη έγκυρος κωδικός διακριτικού',
    'redeemToken.invoicePaidSuccess': 'Η Τιμολόγηση Πληρώθηκε με Επιτυχία!',
    'redeemToken.invoicePaidSuccessDesc': 'Η τιμολόγηση {{invoiceKey}} έχει πληρωθεί αυτόματα.',
    'redeemToken.tokenRedeemedSuccess': 'Το Διακριτικό Εξαργυρώθηκε με Επιτυχία!',
    'redeemToken.tokenRedeemedSuccessDesc': 'Το διακριτικό {{tokenKey}} έχει εξαργυρωθεί στον λογαριασμό σας.',
    'redeemToken.tokenProcessingFailed': 'Η Επεξεργασία Διακριτικού Απέτυχε',
    'redeemToken.tokenProcessingFailedDesc': 'Δεν ήταν δυνατή η επεξεργασία του διακριτικού. Παρακαλώ ελέγξτε τον κωδικό και δοκιμάστε ξανά.',
    'redeemToken.invoicePaymentCanceled': 'Η Πληρωμή Τιμολόγησης Ακυρώθηκε',
    'redeemToken.invoicePaymentCanceledDesc': 'Επιλέξατε να μην πληρώσετε την τιμολόγηση αυτή τη στιγμή.',
    'redeemToken.tokenRedemptionCanceled': 'Η Εξαργύρωση Διακριτικού Ακυρώθηκε',
    'redeemToken.tokenRedemptionCanceledDesc': 'Επιλέξατε να μην εξαργυρώσετε το διακριτικό αυτή τη στιγμή.',
    'redeemToken.tokenCode': 'Κωδικός Διακριτικού',
    'redeemToken.enterCode': 'Εισάγετε τον κωδικό διακριτικού 6 χαρακτήρων ή επικολλήστε τον',
    'redeemToken.redeeming': 'Εξαργύρωση...',
    'redeemToken.redeemToken': 'Εξαργύρωση Διακριτικού',
    'redeemToken.scanQRCode': 'Σάρωση QR Κωδικού',
    'redeemToken.partialPaymentSuccess': 'Μερική Πληρωμή Επιτυχής!',
    'redeemToken.paymentSuccess': 'Πληρωμή Επιτυχής!',
    'redeemToken.paymentSuccessDesc': 'Πληρώθηκε με επιτυχία {{currency}} {{amount}} για την τιμολόγηση{{isPartial}}.',
    'redeemToken.isIDToken': 'Αυτό είναι διακριτικό ταυτότητας',
    'redeemToken.idTokenHint': 'Τα διακριτικά ταυτότητας επαληθεύουν την ταυτότητα· δεν μεταφέρονται χρήματα',
    'redeemToken.idTokenVerified': 'Ταυτότητα επαληθεύτηκε',
    'redeemToken.idTokenRedeemedSuccess': 'Το διακριτικό ταυτότητας εξαργυρώθηκε με επιτυχία',
    'redeemToken.continue': 'Συνέχεια',
    'redeemToken.redemptionPanelIntro': 'Review amount, fees, and net below. Then confirm or choose not to proceed.',
    'redeemToken.tokenValueLabel': 'Token value',
    'redeemToken.processingFeeLabel': 'Processing fee',
    'redeemToken.netAmountReceivedLabel': 'Net amount received',
    'redeemToken.tokenCodeLabel': 'Token code',
    'redeemToken.processing': 'Processing...',
    'redeemToken.confirmDeposit': 'Confirm deposit',
    'redeemToken.doNothing': 'Do nothing',
    'redeemToken.depositFullAmount': 'Deposit full amount',
    'redeemToken.depositAmount': 'Deposit {{amount}}',
    'redeemToken.invoiceRedemptionIntro': 'Review payment amount, fees, and total below. Then pay or choose not to proceed.',
    'redeemToken.amountDueLabel': 'Amount due (remaining)',
    'redeemToken.totalDebitedLabel': 'Total debited from balance',
    'redeemToken.confirmPayInvoice': 'Confirm payment',
    'redeemToken.payDifferentAmount': 'Pay a different amount',
  },
  ro: {
    ...applyCashTokenTranslations,
    'redeemToken.noDataScanned': 'Nu au fost scanate date.',
    'redeemToken.invalidQRCode': 'Format cod QR invalid.',
    'redeemToken.noCodeExtracted': 'Nu s-a putut extrage un cod din scanarea QR.',
    'redeemToken.mustBeLoggedIn': 'Trebuie să fiți autentificat pentru a utiliza tokenuri. Vă rugăm autentificați-vă și încercați din nou.',
    'redeemToken.enterCompleteCode': 'Vă rugăm introduceți un cod complet de 6 caractere.',
    'redeemToken.invalidTokenCode': 'Cod token invalid',
    'redeemToken.invoicePaidSuccess': 'Factura a Fost Plătită cu Succes!',
    'redeemToken.invoicePaidSuccessDesc': 'Factura {{invoiceKey}} a fost plătită automat.',
    'redeemToken.tokenRedeemedSuccess': 'Tokenul a Fost Utilizat cu Succes!',
    'redeemToken.tokenRedeemedSuccessDesc': 'Tokenul {{tokenKey}} a fost utilizat în contul dvs.',
    'redeemToken.tokenProcessingFailed': 'Procesarea Tokenului a Eșuat',
    'redeemToken.tokenProcessingFailedDesc': 'Nu s-a putut procesa tokenul. Vă rugăm verificați codul și încercați din nou.',
    'redeemToken.invoicePaymentCanceled': 'Plata Facturii a Fost Anulată',
    'redeemToken.invoicePaymentCanceledDesc': 'Ați ales să nu plătiți factura în acest moment.',
    'redeemToken.tokenRedemptionCanceled': 'Utilizarea Tokenului a Fost Anulată',
    'redeemToken.tokenRedemptionCanceledDesc': 'Ați ales să nu utilizați tokenul în acest moment.',
    'redeemToken.tokenCode': 'Cod Token',
    'redeemToken.enterCode': 'Introduceți codul tokenului de 6 caractere sau lipiți-l',
    'redeemToken.redeeming': 'Se utilizează...',
    'redeemToken.redeemToken': 'Utilizează Tokenul',
    'redeemToken.scanQRCode': 'Scanează Codul QR',
    'redeemToken.partialPaymentSuccess': 'Plată Parțială Reușită!',
    'redeemToken.paymentSuccess': 'Plată Reușită!',
    'redeemToken.paymentSuccessDesc': 'S-a plătit cu succes {{currency}} {{amount}} pentru factura{{isPartial}}.',
    'redeemToken.isIDToken': 'Acesta este un token de identitate',
    'redeemToken.idTokenHint': 'Tokenurile de identitate verifică identitatea; nu se transferă bani',
    'redeemToken.idTokenVerified': 'Identitate verificată',
    'redeemToken.idTokenRedeemedSuccess': 'Tokenul de identitate a fost utilizat cu succes',
    'redeemToken.continue': 'Continuă',
    'redeemToken.redemptionPanelIntro': 'Review amount, fees, and net below. Then confirm or choose not to proceed.',
    'redeemToken.tokenValueLabel': 'Token value',
    'redeemToken.processingFeeLabel': 'Processing fee',
    'redeemToken.netAmountReceivedLabel': 'Net amount received',
    'redeemToken.tokenCodeLabel': 'Token code',
    'redeemToken.processing': 'Processing...',
    'redeemToken.confirmDeposit': 'Confirm deposit',
    'redeemToken.doNothing': 'Do nothing',
    'redeemToken.depositFullAmount': 'Deposit full amount',
    'redeemToken.depositAmount': 'Deposit {{amount}}',
    'redeemToken.invoiceRedemptionIntro': 'Review payment amount, fees, and total below. Then pay or choose not to proceed.',
    'redeemToken.amountDueLabel': 'Amount due (remaining)',
    'redeemToken.totalDebitedLabel': 'Total debited from balance',
    'redeemToken.confirmPayInvoice': 'Confirm payment',
    'redeemToken.payDifferentAmount': 'Pay a different amount',
  },
  pt: {
    ...applyCashTokenTranslations,
    'redeemToken.noDataScanned': 'Nenhum dado escaneado.',
    'redeemToken.invalidQRCode': 'Formato de código QR inválido.',
    'redeemToken.noCodeExtracted': 'Não foi possível extrair um código da varredura QR.',
    'redeemToken.mustBeLoggedIn': 'Você deve estar logado para resgatar tokens. Por favor, faça login e tente novamente.',
    'redeemToken.enterCompleteCode': 'Por favor, insira um código completo de 6 caracteres.',
    'redeemToken.invalidTokenCode': 'Código de token inválido',
    'redeemToken.invoicePaidSuccess': 'Fatura Paga com Sucesso!',
    'redeemToken.invoicePaidSuccessDesc': 'A fatura {{invoiceKey}} foi paga automaticamente.',
    'redeemToken.tokenRedeemedSuccess': 'Token Resgatado com Sucesso!',
    'redeemToken.tokenRedeemedSuccessDesc': 'O token {{tokenKey}} foi resgatado na sua conta.',
    'redeemToken.tokenProcessingFailed': 'Processamento do Token Falhou',
    'redeemToken.tokenProcessingFailedDesc': 'Não foi possível processar o token. Verifique o código e tente novamente.',
    'redeemToken.invoicePaymentCanceled': 'Pagamento da Fatura Cancelado',
    'redeemToken.invoicePaymentCanceledDesc': 'Você optou por não pagar a fatura neste momento.',
    'redeemToken.tokenRedemptionCanceled': 'Resgate do Token Cancelado',
    'redeemToken.tokenRedemptionCanceledDesc': 'Você optou por não resgatar o token neste momento.',
    'redeemToken.tokenCode': 'Código do Token',
    'redeemToken.enterCode': 'Insira o código do token de 6 caracteres ou cole-o',
    'redeemToken.redeeming': 'Resgatando...',
    'redeemToken.redeemToken': 'Resgatar Token',
    'redeemToken.scanQRCode': 'Escanear Código QR',
    'redeemToken.partialPaymentSuccess': 'Pagamento Parcial Bem-sucedido!',
    'redeemToken.paymentSuccess': 'Pagamento Bem-sucedido!',
    'redeemToken.paymentSuccessDesc': 'Pago com sucesso {{currency}} {{amount}} para a fatura{{isPartial}}.',
    'redeemToken.isIDToken': 'Este é um token de identidade',
    'redeemToken.idTokenHint': 'Tokens de identidade verificam a identidade; nenhum dinheiro é transferido',
    'redeemToken.idTokenVerified': 'Identidade verificada',
    'redeemToken.idTokenRedeemedSuccess': 'Token de identidade resgatado com sucesso',
    'redeemToken.continue': 'Continuar',
    'redeemToken.redemptionPanelIntro': 'Review amount, fees, and net below. Then confirm or choose not to proceed.',
    'redeemToken.tokenValueLabel': 'Token value',
    'redeemToken.processingFeeLabel': 'Processing fee',
    'redeemToken.netAmountReceivedLabel': 'Net amount received',
    'redeemToken.tokenCodeLabel': 'Token code',
    'redeemToken.processing': 'Processing...',
    'redeemToken.confirmDeposit': 'Confirm deposit',
    'redeemToken.doNothing': 'Do nothing',
    'redeemToken.depositFullAmount': 'Deposit full amount',
    'redeemToken.depositAmount': 'Deposit {{amount}}',
    'redeemToken.invoiceRedemptionIntro': 'Review payment amount, fees, and total below. Then pay or choose not to proceed.',
    'redeemToken.amountDueLabel': 'Amount due (remaining)',
    'redeemToken.totalDebitedLabel': 'Total debited from balance',
    'redeemToken.confirmPayInvoice': 'Confirm payment',
    'redeemToken.payDifferentAmount': 'Pay a different amount',
  },
};
